(ns iris.logs.events
  (:require
   [re-frame.core :as re-frame]
   [re-frame.db :as re-frame-db]
   [ajax.core :as ajax]
   [iris.events :as events]
   [iris.db :as db]
   [iris.posts.events :as posts-events]))


;; ---------------------------------------------------------------------------
;; Default state helpers
;; ---------------------------------------------------------------------------

(def default-query (:query (:logs db/default-db)))

(def default-logs (:logs db/default-db))

(def ^:private use-log-fixture? false) ;; TODO: set to false once Log.List backend is ready

(defn- log-events-result-data [data]
  (get-in data [:result :data]))


;; ---------------------------------------------------------------------------
;; Global logs dashboard (no ruid filter)
;; ---------------------------------------------------------------------------

(re-frame/reg-event-fx
 ::load-logs-dashboard
 (fn [{:keys [db]} _]
   {:db (assoc db :logs (-> default-logs
                             (assoc-in [:panel :kind] :global)))}))

(re-frame/reg-event-fx
 ::sync-logs-query
 (fn [{:keys [db]} [_ query-params]]
   (let [page     (js/parseInt (or (:page query-params) "1"))
         activity (or (:activity query-params) "all")]
     {:db (-> db
              (assoc-in [:logs :query :page] page)
              (assoc-in [:logs :query :activity] activity)
              (assoc-in [:logs :panel :events] nil))
      :dispatch [::fetch-global-log-events]})))


;; ---------------------------------------------------------------------------
;; Post dashboard
;; ---------------------------------------------------------------------------

(re-frame/reg-event-fx
 ::load-post-dashboard
 (fn [{:keys [db]} [_ ruid]]
   {:db (assoc db :logs default-logs)
    :dispatch-n [[::posts-events/reset-screening-status-request-tracking]
                 [::fetch-post ruid]]}))

(re-frame/reg-event-fx
 ::sync-post-query
 (fn [{:keys [db]} [_ ruid query-params]]
   (let [page     (js/parseInt (or (:page query-params) "1"))
         activity (or (:activity query-params) "all")]
     {:db (-> db
              (assoc-in [:logs :query :page] page)
              (assoc-in [:logs :query :activity] activity)
              (assoc-in [:logs :panel :events] nil))
      :dispatch [::fetch-post-log-events ruid]})))

;; ---------------------------------------------------------------------------
;; Thread dashboard
;; ---------------------------------------------------------------------------

(re-frame/reg-event-fx
 ::load-thread-dashboard
 (fn [{:keys [db]} [_ id]]
   (let [ruid (str "+" id)]
     {:db (assoc db :logs (-> default-logs
                               (assoc-in [:panel :kind] :thread)))
      :dispatch-n [[::fetch-thread-board id]
                   [::posts-events/http-get-screening-status {:ruid ruid} {:prevent-http-complete true}]]})))

(re-frame/reg-event-fx
 ::sync-thread-query
 (fn [{:keys [db]} [_ id query-params]]
   (let [page     (js/parseInt (or (:page query-params) "1"))
         activity (or (:activity query-params) "all")]
     {:db (-> db
              (assoc-in [:logs :query :page] page)
              (assoc-in [:logs :query :activity] activity)
              (assoc-in [:logs :panel :events] nil))
      :dispatch [::fetch-thread-log-events id]})))

(re-frame/reg-event-db
 ::fetch-thread-board-success
 (fn [db [_ data]]
   (if-let [board (get-in data [:result :data :board])]
     (assoc-in db [:logs :panel :board] board)
     db)))

(re-frame/reg-event-db
 ::fetch-thread-board-failure
 (fn [db] db))

(re-frame/reg-event-fx
 ::fetch-thread-board
 (fn [_ [_ id]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id      0
                     :method  "Post2a.Get"
                     :params  {:options {:debug false}
                               :data    {:ruid (str "@OP+" id)}}}
                    [::fetch-thread-board-success]
                    [::fetch-thread-board-failure])))

(re-frame/reg-event-db
 ::fetch-thread-log-events-success
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (-> db
       (assoc-in [:logs :panel :events] (log-events-result-data data))
       (assoc-in [:logs :query :has-next] (get-in data [:result :meta :has_next])))))

(re-frame/reg-event-db
 ::fetch-thread-log-events-failure
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (assoc-in db [:message] "Failed to load thread log events.")))

(re-frame/reg-event-fx
 ::fetch-thread-log-events
 (fn [{:keys [db]} [_ id]]
   (let [query    (get-in db [:logs :query])
         activity (:activity query)
         page     (:page query 1)
         limit    100]
     (if use-log-fixture?
       {:http-xhrio (events/track-http-xhrio
                     "Log fixture"
                     {:method          :get
                      :uri             "/fixtures/log_query_post.json"
                      :timeout         8000
                      :response-format (ajax/json-response-format {:keywords? true})
                      :on-success      [::fetch-thread-log-events-success]
                      :on-failure      [::fetch-thread-log-events-failure]})}
       (events/post-rpc {:jsonrpc "2.0"
                         :id      0
                         :method  "Log.List"
                         :params  {:options {:debug false}
                                   :data    {:ruid   (str "+" id)
                                             :deep     true
                                             :activity (when (not= activity "all") activity)
                                             :page     page
                                             :limit    limit}}}
                        [::fetch-thread-log-events-success]
                        [::fetch-thread-log-events-failure])))))


;; -- fetch post (real API) ---------------------------------------------------

(re-frame/reg-event-db
 ::fetch-post-success
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (if-let [post (get-in data [:result :data])]
     (let [ruid  (:ruid post)
           m-eid (get-in post [:author :eid :m_eid])
           l-eid (get-in post [:author :eid :l_eid])]
       (when m-eid (re-frame/dispatch [::posts-events/http-get-scope-eid-metadata m-eid]))
       (when l-eid (re-frame/dispatch [::posts-events/http-get-scope-eid-metadata l-eid]))
       (when ruid
         (re-frame/dispatch [::posts-events/http-get-screening-status
                             {:ruid ruid}
                             {:prevent-http-complete true}]))
       (posts-events/request-screening-statuses
        db
        [post]
        {:prevent-http-complete true})
       (-> db
           (assoc-in  [:logs :panel :data] post)))
     db)))

(re-frame/reg-event-db
 ::fetch-post-failure
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (assoc-in db [:message] "Failed to load post data.")))

(re-frame/reg-event-fx
 ::fetch-post
 (fn [{:keys [db]} [_ ruid]]
   ;; initialise the panel shape so :events slot exists before log response arrives
   (let [db' (assoc-in db [:logs :panel] {:kind :post :data nil :events []})]
     (merge {:db db'}
            (events/post-rpc {:jsonrpc "2.0"
                               :id 0
                               :method "Post2a.Get"
                               :params {:options {:debug false}
                                        :data {:ruid ruid
                                               :include_screening_status false}}}
                              [::fetch-post-success]
                              [::fetch-post-failure])))))

;; Silent re-fetch: does NOT reset panel data, so the UI stays stable
;; (no scroll jump, no loading flash). Used after moderator actions.
(re-frame/reg-event-fx
 ::refresh-post
 (fn [{:keys [db]} [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Post2a.Get"
                     :params {:options {:debug false}
                              :data {:ruid ruid
                                     :include_screening_status false}}}
                    [::fetch-post-success]
                    [::fetch-post-failure])))


;; -- fetch post log events --------------------------------------------------

(re-frame/reg-event-db
 ::fetch-post-log-events-success
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (-> db
       (assoc-in [:logs :panel :events] (log-events-result-data data))
       (assoc-in [:logs :query :has-next] (get-in data [:result :meta :has_next])))))

(re-frame/reg-event-db
 ::fetch-post-log-events-failure
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (assoc-in db [:message] "Failed to load log events.")))

(re-frame/reg-event-fx
 ::fetch-post-log-events
 (fn [{:keys [db]} [_ ruid]]
   (let [query    (get-in db [:logs :query])
         activity (or (:activity query) "all")
         page     (or (:page query) 1)
         limit    100]
     (if use-log-fixture?
       ;; --- fixture ---
       {:http-xhrio (events/track-http-xhrio
                     "Log fixture"
                     {:method          :get
                      :uri             "/fixtures/log_query_post.json"
                      :timeout         8000
                      :response-format (ajax/json-response-format {:keywords? true})
                      :on-success      [::fetch-post-log-events-success]
                      :on-failure      [::fetch-post-log-events-failure]})}
       ;; --- real RPC: Log.List ---
       (events/post-rpc {:jsonrpc "2.0"
                         :id      0
                         :method  "Log.List"
                         :params  {:options {:debug false}
                                   :data    {:ruid     ruid
                                             :deep     false
                                             :activity (when (not= activity "all") activity)
                                             :page     page
                                             :limit    limit}}}
                        [::fetch-post-log-events-success]
                        [::fetch-post-log-events-failure])))))


;; ---------------------------------------------------------------------------
;; Header dashboard
;; ---------------------------------------------------------------------------

(re-frame/reg-event-fx
 ::load-header-dashboard
 (fn [{:keys [db]} [_ header]]
   (let [ruid (str "/" header)]
     {:db (assoc db :logs (-> default-logs
                               (assoc-in [:panel :kind] :header)))
      :dispatch-n [[::posts-events/http-get-header ruid]
                   [::posts-events/http-get-screening-status {:ruid ruid} {:prevent-http-complete true}]]})))

(re-frame/reg-event-fx
 ::sync-header-query
 (fn [{:keys [db]} [_ header query-params]]
   (let [page     (js/parseInt (or (:page query-params) "1"))
         activity (or (:activity query-params) "all")]
     {:db (-> db
              (assoc-in [:logs :query :page] page)
              (assoc-in [:logs :query :activity] activity)
              (assoc-in [:logs :panel :events] nil))
      :dispatch [::fetch-header-log-events header]})))

(re-frame/reg-event-db
 ::fetch-header-log-events-success
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (-> db
       (assoc-in [:logs :panel :events] (log-events-result-data data))
       (assoc-in [:logs :query :has-next] (get-in data [:result :meta :has_next])))))

(re-frame/reg-event-db
 ::fetch-header-log-events-failure
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (assoc-in db [:message] "Failed to load header log events.")))

(re-frame/reg-event-fx
 ::fetch-header-log-events
 (fn [{:keys [db]} [_ header]]
   (let [query    (get-in db [:logs :query])
         activity (:activity query)
         page     (:page query 1)
         limit    100
         ruid     (str "/" header)]
     (events/post-rpc {:jsonrpc "2.0"
                       :id      0
                       :method  "Log.List"
                       :params  {:options {:debug false}
                                 :data    {:ruid     ruid
                                           :deep     true
                                           :activity (when (not= activity "all") activity)
                                           :page     page
                                           :limit    limit}}}
                      [::fetch-header-log-events-success]
                      [::fetch-header-log-events-failure]))))

;; ---------------------------------------------------------------------------
;; User dashboard
;; ---------------------------------------------------------------------------

(re-frame/reg-event-fx
 ::load-user-dashboard
 (fn [{:keys [db]} [_ user]]
   (let [ruid (str "=" user)]
     {:db (assoc db :logs (-> default-logs
                               (assoc-in [:panel :kind] :user)))
      :dispatch-n [[::posts-events/http-get-log-timespan ruid]
                   [::posts-events/http-get-screening-status {:ruid ruid} {:prevent-http-complete true}]]})))

(re-frame/reg-event-fx
 ::sync-user-query
 (fn [{:keys [db]} [_ user query-params]]
   (let [page     (js/parseInt (or (:page query-params) "1"))
         activity (or (:activity query-params) "all")]
     {:db (-> db
              (assoc-in [:logs :query :page] page)
              (assoc-in [:logs :query :activity] activity)
              (assoc-in [:logs :panel :events] nil))
      :dispatch [::fetch-user-log-events user]})))

(re-frame/reg-event-db
 ::fetch-user-log-events-success
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (-> db
       (assoc-in [:logs :panel :events] (log-events-result-data data))
       (assoc-in [:logs :query :has-next] (get-in data [:result :meta :has_next])))))

(re-frame/reg-event-db
 ::fetch-user-log-events-failure
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (assoc-in db [:message] "Failed to load user log events.")))

(re-frame/reg-event-fx
 ::fetch-user-log-events
 (fn [{:keys [db]} [_ user]]
   (let [query    (get-in db [:logs :query])
         activity (:activity query)
         page     (:page query 1)
         limit    100
         ruid     (str "=" user)]
     (events/post-rpc {:jsonrpc "2.0"
                       :id      0
                       :method  "Log.List"
                       :params  {:options {:debug false}
                                 :data    {:ruid     ruid
                                           :deep     true
                                           :activity (when (not= activity "all") activity)
                                           :page     page
                                           :limit    limit}}}
                      [::fetch-user-log-events-success]
                      [::fetch-user-log-events-failure]))))

;; ---------------------------------------------------------------------------
;; IP dashboard
;; ---------------------------------------------------------------------------

(re-frame/reg-event-fx
 ::load-ip-dashboard
 (fn [{:keys [db]} [_ ip]]
   (let [ruid (str "^" ip)]
     {:db (assoc db :logs (-> default-logs
                               (assoc-in [:panel :kind] :ip)))
      :dispatch-n [[::posts-events/http-get-log-timespan ruid]
                   [::posts-events/http-get-screening-status {:ruid ruid} {:prevent-http-complete true}]]})))

(re-frame/reg-event-fx
 ::sync-ip-query
 (fn [{:keys [db]} [_ ip query-params]]
   (let [page     (js/parseInt (or (:page query-params) "1"))
         activity (or (:activity query-params) "all")]
     {:db (-> db
              (assoc-in [:logs :query :page] page)
              (assoc-in [:logs :query :activity] activity)
              (assoc-in [:logs :panel :events] nil))
      :dispatch [::fetch-ip-log-events ip]})))

(re-frame/reg-event-db
 ::fetch-ip-log-events-success
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (-> db
       (assoc-in [:logs :panel :events] (log-events-result-data data))
       (assoc-in [:logs :query :has-next] (get-in data [:result :meta :has_next])))))

(re-frame/reg-event-db
 ::fetch-ip-log-events-failure
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (assoc-in db [:message] "Failed to load IP log events.")))

(re-frame/reg-event-fx
 ::fetch-ip-log-events
 (fn [{:keys [db]} [_ ip]]
   (let [query    (get-in db [:logs :query])
         activity (:activity query)
         page     (:page query 1)
         limit    100
         ruid     (str "^" ip)]
     (events/post-rpc {:jsonrpc "2.0"
                       :id      0
                       :method  "Log.List"
                       :params  {:options {:debug false}
                                 :data    {:ruid     ruid
                                           :deep     true
                                           :activity (when (not= activity "all") activity)
                                           :page     page
                                           :limit    limit}}}
                      [::fetch-ip-log-events-success]
                      [::fetch-ip-log-events-failure]))))

;; ---------------------------------------------------------------------------
;; EID dashboard
;; ---------------------------------------------------------------------------

(re-frame/reg-event-fx
 ::load-eid-dashboard
 (fn [{:keys [db]} [_ eid]]
   {:db (assoc db :logs (-> default-logs
                             (assoc-in [:panel :kind] :eid)))
    :dispatch-n [[::posts-events/http-get-scope-eid-metadata eid]
                 [::posts-events/http-get-log-timespan eid]
                 [::posts-events/http-get-screening-status {:ruid eid} {:prevent-http-complete true}]]}))

(re-frame/reg-event-fx
 ::sync-eid-query
 (fn [{:keys [db]} [_ eid query-params]]
   (let [page     (js/parseInt (or (:page query-params) "1"))
         activity (or (:activity query-params) "all")]
     {:db (-> db
              (assoc-in [:logs :query :page] page)
              (assoc-in [:logs :query :activity] activity)
              (assoc-in [:logs :panel :events] nil))
      :dispatch [::fetch-eid-log-events eid]})))

(re-frame/reg-event-db
 ::fetch-eid-log-events-success
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (-> db
       (assoc-in [:logs :panel :events] (log-events-result-data data))
       (assoc-in [:logs :query :has-next] (get-in data [:result :meta :has_next])))))

(re-frame/reg-event-db
 ::fetch-eid-log-events-failure
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (assoc-in db [:message] "Failed to load EID log events.")))

(re-frame/reg-event-fx
 ::fetch-eid-log-events
 (fn [{:keys [db]} [_ eid]]
   (let [query    (get-in db [:logs :query])
         activity (:activity query)
         page     (:page query 1)
         limit    100]
     (events/post-rpc {:jsonrpc "2.0"
                       :id      0
                       :method  "Log.List"
                       :params  {:options {:debug false}
                                 :data    {:ruid     eid
                                           :deep     true
                                           :activity (when (not= activity "all") activity)
                                           :page     page
                                           :limit    limit}}}
                      [::fetch-eid-log-events-success]
                      [::fetch-eid-log-events-failure]))))

;; ---------------------------------------------------------------------------
;; Watch moderator actions from posts module and re-fetch if logs panel is
;; currently showing the same post. This keeps the moderator bar in sync
;; without any coupling in iris.posts.events.
;; ---------------------------------------------------------------------------

;; ---------------------------------------------------------------------------
;; Global logs fetch handlers
;; ---------------------------------------------------------------------------

(re-frame/reg-event-db
 ::fetch-global-log-events-success
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (-> db
       (assoc-in [:logs :panel :events] (log-events-result-data data))
       (assoc-in [:logs :query :has-next] (get-in data [:result :meta :has_next])))))

(re-frame/reg-event-db
 ::fetch-global-log-events-failure
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (assoc-in db [:message] "Failed to load global log events.")))

(re-frame/reg-event-fx
 ::fetch-global-log-events
 (fn [{:keys [db]} _]
   (let [query    (get-in db [:logs :query])
         activity (:activity query)
         page     (:page query 1)
         limit    100]
     (events/post-rpc {:jsonrpc "2.0"
                       :id      0
                       :method  "Log.List"
                       :params  {:options {:debug false}
                                 :data    {:activity (when (not= activity "all") activity)
                                           :page     page
                                           :limit    limit}}}
                      [::fetch-global-log-events-success]
                      [::fetch-global-log-events-failure]))))

;; ---------------------------------------------------------------------------

(re-frame/add-post-event-callback
 ::sync-post-action
 (fn [[event-id ruid _data]]
   (when (= event-id ::posts-events/http-post-action-success)
     (let [db @re-frame-db/app-db]
       (when (= ruid (get-in db [:logs :panel :data :ruid]))
         (re-frame/dispatch [::refresh-post ruid])
         (re-frame/dispatch [::fetch-post-log-events ruid]))))))
